import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaAngleRight, FaHome } from 'react-icons/fa';
import { NavLink, useMatches } from 'react-router-dom';

type RouteHandle = {
  crumb: (data: unknown) => React.ReactElement | undefined;
};

export const Breadcrumbs = () => {
  const matches = useMatches();

  const breadcrumbs = matches
    .filter((match) => match.handle && (match.handle as RouteHandle).crumb)
    .map((match) => ({
      breadcrumb: (match.handle as RouteHandle).crumb(match.data),
      match,
    }));

  return (
    <ChakraV3.Breadcrumb.Root size='lg'>
      <ChakraV3.Breadcrumb.List>
        <ChakraV3.Breadcrumb.Item fontSize='lg'>
          <ChakraV3.Breadcrumb.Link asChild>
            <NavLink to={'/'}>
              <ChakraV3.Icon color='secondary'>
                <FaHome />
              </ChakraV3.Icon>
            </NavLink>
          </ChakraV3.Breadcrumb.Link>
        </ChakraV3.Breadcrumb.Item>
        {breadcrumbs.map(({ match, breadcrumb }, index) => (
          <>
            <ChakraV3.Breadcrumb.Separator>
              <FaAngleRight />
            </ChakraV3.Breadcrumb.Separator>
            <ChakraV3.Breadcrumb.Item key={match.pathname} fontWeight='semibold'>
              <ChakraV3.Breadcrumb.Link
                color={index === breadcrumbs.length - 1 ? 'gray.700' : 'secondary'}
                asChild
              >
                <NavLink to={match.pathname}>{breadcrumb}</NavLink>
              </ChakraV3.Breadcrumb.Link>
            </ChakraV3.Breadcrumb.Item>
          </>
        ))}
      </ChakraV3.Breadcrumb.List>
    </ChakraV3.Breadcrumb.Root>
  );
};
